import LegalPage from "@/components/feature/LegalPage";

export default function TermsOfUse() {
  return (
    <LegalPage
      eyebrow="Terms of Use"
      title="Terms of Use"
      intro="This is a placeholder page describing the general terms for using the Florida Family Clinic website."
    >
      <h2 className="font-heading text-lg font-semibold text-foreground-950">Informational purpose</h2>
      <p>
        The content on this website is provided for general informational purposes only and is not a
        substitute for professional medical advice, diagnosis, or treatment. Always seek the advice
        of a qualified health provider with any questions you may have regarding a medical condition.
      </p>

      <h2 className="font-heading text-lg font-semibold text-foreground-950">No doctor-patient relationship</h2>
      <p>
        Submitting an inquiry through this website does not create a doctor-patient relationship.
        For medical emergencies, call 911 or contact emergency services.
      </p>

      <h2 className="font-heading text-lg font-semibold text-foreground-950">Accuracy of information</h2>
      <p>
        Service descriptions on this website are provided for general reference. Service
        availability and suitability are determined by the clinic in discussion with each patient.
      </p>

      <p className="text-sm text-foreground-500">
        This placeholder content is provided for informational purposes and should be replaced with
        complete terms before publishing.
      </p>
    </LegalPage>
  );
}